// src/components/common/Subscription/SubscriptionGuard.jsx
import React from 'react';
import { useSubscriptionStatus } from '../../../hooks/useSubscriptionStatus';
import SubscriptionExpiredModal from './SubscriptionExpiredModal';

/**
 * SubscriptionGuard Component
 * Wraps routes that require an active subscription
 * Shows SubscriptionExpiredModal if subscription is expired/cancelled/suspended
 */
const SubscriptionGuard = ({ children }) => {
  const { isActive } = useSubscriptionStatus();

  return (
    <>
      {children}
      {!isActive && <SubscriptionExpiredModal />}
    </>
  );
};

export default SubscriptionGuard;